import queryString from "query-string";
import { paths } from "src/const";
import { validateReturnToUrl } from "./validateReturnToUrl";

// function to create a redirection url taking the return_to parameter
// preserving the params inside the return_to url
// adding email and voucherId if they exist
export const createRedirectionWithParams = (return_to: string): string => {
	if (!validateReturnToUrl(return_to)) {
		return paths.home;
	}

	const { query: webParams } = queryString.parseUrl(window.location.href);
	const { url, query } = queryString.parseUrl(return_to);
	const updatedQuery = {
		...query,
		email: webParams?.email ? String(webParams?.email || "")?.toLowerCase() : undefined,
		voucherId: webParams?.voucherId ? webParams?.voucherId : undefined,
	};
	const finalUrl = queryString.stringifyUrl({
		url,
		query: updatedQuery,
	});
	return finalUrl;
};
